<form #housetypeForm="ngForm" class="editForm customMat" novalidate>
    <div class="tab-pane fade in active">
        <div class="flex-center">
            <button fxHide [fxShow.gt-xs]="true" mat-raised-button class="back" (click)="goToPrevious(housetypeForm);$event.preventDefault();">< zurück</button>
            <h4 class="sub">{{title}}</h4>
            <button fxHide [fxShow.gt-xs]="true" mat-raised-button class="next" disabled>weiter ></button>
        </div>
        <div class='row'>
            <div class='col-xs-offset-1 col-xs-10'>
                <div class="row flex-strech">
                    <div class='col-xs-offset-2 col-xs-8 col-sm-offset-0 col-sm-3'>
                        <input class="item p-0 h-0" type="image" src="assets/images/icon_einfamilienhaus.gif" name="type" [class.item-active]="type.type == '174370000'" (click)="goToNext('174370000');$event.preventDefault();">
                    </div>
                    <div class='col-xs-offset-2 col-xs-8 col-sm-offset-0 col-sm-3'>
                        <input class="item p-0 h-0" type="image" src="assets/images/icon_reihenhaus.gif" name="type" [class.item-active]="type.type == '174370001'" (click)="goToNext('174370001');$event.preventDefault();">
                    </div>
                    <div class='col-xs-offset-2 col-xs-8 col-sm-offset-0 col-sm-3'>
                        <input class="item p-0 h-0" type="image" src="assets/images/icon_doppelhaus.gif" name="type" [class.item-active]="type.type == '174370002'" (click)="goToNext('174370002');$event.preventDefault();">
                    </div>
                    <div class='col-xs-offset-2 col-xs-8 col-sm-offset-0 col-sm-3'>
                        <input class="item p-0 h-0" type="image" src="assets/images/icon_mehrfamilienhaus.gif" name="type" [class.item-active]="type.type == '174370003'" (click)="goToNext('174370003');$event.preventDefault();">
                    </div>
                </div>      
            </div>
        </div>
        <div class="flex-center">
            <button fxShow [fxHide.gt-xs]="true" mat-raised-button class="back" (click)="goToPrevious(housetypeForm);$event.preventDefault();">< zurück</button>
            <button fxShow [fxHide.gt-xs]="true" mat-raised-button class="next" disabled>weiter ></button>
        </div>
    </div>
</form>
<app-footer [progress]="20"></app-footer>